// extracted by mini-css-extract-plugin
export default {"cls1":"WhoCanSeePost-cls1___4be81a97646e105dd2e","cls2":"WhoCanSeePost-cls2___3aa4fed6506ad2207fd WhoCanSeePost-cls1___4be81a97646e105dd2e"};